import { useParams } from 'react-router-dom';
import { useGetModuleSpecsQuery } from '../../../../api/queries/getModuleSpecs';
import { ModuleType } from '../../../../api/types';
import LoadingElement from '../../../../components/LoadingElement';
import NotFoundResult from '../../../../components/results/NotFoundResult';
import UpdateUserlikeChatbotSettingInnerPage from './UpdateUserlikeChatbotSettingInnerPage';

const UpdateUserlikeChatbotSettingPage = () => {
    const { moduleId, settingsId } = useParams<{ moduleId: string; settingsId: string }>();

    const { data, loading } = useGetModuleSpecsQuery({
        fetchPolicy: 'cache-first',
        variables: { moduleId },
    });

    if (!data && !loading) {
        return <NotFoundResult />;
    }

    if (loading) {
        return <LoadingElement />;
    }

    const { module } = data;

    if (module.__typename !== ModuleType.UserlikeChatbotModule) {
        return <NotFoundResult />;
    }

    const settings = module.chatbotSettings.find(item => item.id === settingsId);

    if (!settings) {
        return <NotFoundResult />;
    }

    return <UpdateUserlikeChatbotSettingInnerPage module={module} settings={settings} />;
};

export default UpdateUserlikeChatbotSettingPage;
